// extracted by mini-css-extract-plugin
module.exports = {"row":"profile_row__1eHt2","avatar":"profile_avatar__gH_IL"};